module.exports = __webpack_public_path__ + "fonts/eab178ecaf3c206f30b478f870b88b33.txt";